import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';
import { facetTypeDetails } from '../../../utility/types/facetTypeDetails';

class AlertTriggeredFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.ALERT_TRIGGERED;
    this.displayName = 'Alert Triggered';
    this.description = 'Include alerts with the status of...';
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.EQUAL_TO_VALUE]: 'Triggered',
      [OperatorTypes.NOT_EQUAL_TO]: 'Not Triggered',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  // eslint-disable-next-line class-methods-use-this
  getDisplayValue1() {
    return '';
  }

  // eslint-disable-next-line class-methods-use-this
  fromDisplayValue1() {
    return 1;
  }

  getOperatorSelectOptions() {
    const facet = facetTypeDetails[this.facetType];
    return [
      {
        value: facet.validOperators[0],
        label: this.getOperatorDescription(facet.validOperators[0]),
      },
      {
        value: facet.validOperators[1],
        label: this.getOperatorDescription(facet.validOperators[1]),
      },
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip(filtersByOperatorObj) {
    if (filtersByOperatorObj && Object.values(filtersByOperatorObj).length) {
      const filtersArray = Object.values(filtersByOperatorObj)[0];
      const filter = filtersArray[0];
      return `Alert is ${this.getOperatorDescription(filter.operatorId)}`;
    }
    return '';
  }
}
export default AlertTriggeredFacet;
